// client/src/shared/components/PointsPopover/index.js
import React from 'react';
import PropTypes from 'prop-types';
import BadgePopover from '../BadgePopover';
import { getPointsBreakdown } from '../../utils/formatters';

const PointsPopover = ({ activity, popoverId, placement = 'top', children }) => {
    const b = getPointsBreakdown(activity);

    const body = (
        <>
            <p className="mb-1">
                <strong>{b.activityType}</strong>
            </p>
            <p className="mb-1">
                {b.formulaLine} = <strong>{b.distancePoints.toFixed(1)} distance pts</strong>
            </p>
            {b.caloriesPoints > 0 && (
                <p className="mb-1">
                    {parseFloat(activity.calories).toFixed(0)} kcal ÷ 100 = <strong>{b.caloriesPoints.toFixed(1)} calorie pts</strong>
                </p>
            )}
            {b.caloriesPoints > 0 && (
                <p className="mb-1 text-muted" style={{ fontSize: '0.85em' }}>
                    {b.usedCalories
                        ? 'Used calorie points (higher).'
                        : 'Used distance points (higher).'}
                </p>
            )}
            {b.penaltyFactor < 1.0 && (
                <p className="mb-1">
                    {b.rawPoints.toFixed(1)} raw pts × {b.penaltyFactor} = <strong>{b.effectivePoints.toFixed(1)} pts</strong>
                </p>
            )}
            <p className="mb-0">
                <strong>Total: {b.effectivePoints.toFixed(1)} pts</strong>
            </p>
        </>
    );

    return (
        <BadgePopover
            popoverId={popoverId}
            header="Points Calculation"
            body={body}
            placement={placement}
        >
            {children}
        </BadgePopover>
    );
};

PointsPopover.propTypes = {
    activity: PropTypes.shape({
        activityType: PropTypes.string.isRequired,
        distance: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        elevation: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        calories: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        points: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        rawPoints: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
        penaltyFactor: PropTypes.number,
    }).isRequired,
    popoverId: PropTypes.string.isRequired,
    placement: PropTypes.string,
    children: PropTypes.node.isRequired,
};

export default PointsPopover;
